var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"t",rawName:"v-t",value:('user.equipament_maintenance'),expression:"'user.equipament_maintenance'"}],staticClass:"center title white--text",staticStyle:{"position":"relative","text-align":"center","z-index":"1","box-sizing":"border-box","background-color":"#8B0000","padding":"4px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }